import actionType from 'utils/mw/actionType.util';

// noinspection JSUnusedGlobalSymbols
export default actionType('CONFIRM_REGISTRATION');
